/**
 * @deprecated
 */
export class SkuDetails {
    constructor(description, freeTrialPeriod, iconUrl, introductoryPrice, introductoryPriceAmountMicros, introductoryPriceCycles, introductoryPricePeriod, originalJson, originalPrice, originalPriceAmountMicros, price, priceAmountMicros, priceCurrencyCode, sku, subscriptionPeriod, title, type, hashCode, toString) {
        this.description = description;
        this.freeTrialPeriod = freeTrialPeriod;
        this.iconUrl = iconUrl;
        this.introductoryPrice = introductoryPrice;
        this.introductoryPriceAmountMicros = introductoryPriceAmountMicros;
        this.introductoryPriceCycles = introductoryPriceCycles;
        this.introductoryPricePeriod = introductoryPricePeriod;
        this.originalJson = originalJson;
        this.originalPrice = originalPrice;
        this.originalPriceAmountMicros = originalPriceAmountMicros;
        this.price = price;
        this.priceAmountMicros = priceAmountMicros;
        this.priceCurrencyCode = priceCurrencyCode;
        this.sku = sku;
        this.subscriptionPeriod = subscriptionPeriod;
        this.title = title;
        this.type = type;
        this.hashCode = hashCode;
        this.toString = toString;
    }
}
//# sourceMappingURL=SkuDetails.js.map